































import Vue from 'vue';

export default Vue.extend({
  name: 'PageTemplate',
  props: {
    pageTemplate: {
      type: Object as () => PageTemplateResponse,
    },
  },
});
